export class SendTenatToAssetLinkEmail{
    propertyId:string;
    organizationId:string;
    recipientUserId:string;
    jobId:string;
    createdUserId:string;
    completedDate:string;
    completedUserId:string;
    tenantInvitationType : TenantTypes;
    propertyAssetInvitationStatus : PropertyAssetInvitationStatus
    assetInvitationStatus:string;
    lastUpdatedDateTime : string;
    allCompletedInvitations:boolean;
    anyCompletedInvitations : boolean;
    assetId:string;
    isAIGenerated: boolean;
}


export enum TenantTypes {
    All = 0,
    PrimaryTenant = 1,
    SecondaryTenant = 2,
  }

  export enum PropertyAssetInvitationStatus{
    Pending = 0,
    Completed = 1
  }
  